import React from "react";

const RouteExcel = ({
    onChangeFunc,
    passCheckMessage,
    failedRowList,
    rowListCount,
    rowLength,
}: any) => {
    return (
        <>
            <input
                type="file"
                onChange={(e) => onChangeFunc(e.target.files)}
            ></input>
            {passCheckMessage ? <p>{passCheckMessage}</p> : null}
            {rowLength ? (
                <p>
                    EXCEL 展示共 <b style={{ color: "blue" }}>{rowLength}</b> 行，如果行數不同，有可能是未分割EXCEL
                </p>
            ) : null}
            {Object.keys(failedRowList).length
                ? Object.keys(failedRowList).map((key, i) => {
                      return (
                          <p key={"missingInfo" + i}>
                              {i + 1}. <b style={{ color: "blue" }}>{key}</b>{" "}
                              行缺少/錯誤{" "}
                              <b style={{ color: "red" }}>
                                  {failedRowList[key].join(" , ")}
                              </b>
                          </p>
                      );
                  })
                : null}
            {Object.keys(rowListCount).length
                ? Object.keys(rowListCount).map((key) => {
                      return (
                          <div style={{ display: "flex" }}>
                              <p>
                                  <b>{key}:</b>
                              </p>
                              {Object.keys(rowListCount[key]).map(
                                  (value: string) => {
                                      return (
                                          <p style={{ marginLeft: "20px" }}>
                                              <b style={{ color: "blue" }}>
                                                  {value}:{" "}
                                              </b>
                                              <b style={{ color: "red" }}>
                                                  {rowListCount[key][value]}
                                              </b>
                                          </p>
                                      );
                                  }
                              )}
                          </div>
                      );
                  })
                : null}
        </>
    );
};

export default RouteExcel;
